import styled from 'styled-components';

export const StatusBadge = styled.span`
  padding: 0.2rem 1rem;
  border-radius: 4px;
  text-transform: capitalize;
  background-color: ${props => {
    switch (props.value) {
      case 'pending':
        return '#FFC105';
      case 'approved':
        return '#28A744';
      case 'rejected':
        return '#DC3445';
      default:
        return '#007BFF';
    }
  }};
  color: ${props => {
    switch (props.value) {
      case 'pending':
        return '#000 !important';
      case 'approved':
        return '#FFF !important';
      case 'rejected':
        return '#fff !important';
      default:
        return '#fff !important';
    }
  }};
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;
export const Action = styled.button.attrs({
  type: 'button',
})`
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  background: none;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    font-weight: bold;
    font-size: 1rem;
  }
`;

export const ActionHref = Action.withComponent('a');
